module.exports = __webpack_public_path__ + "img/shoutouts.33aa93ea.png";